import { PaymentMethod } from '../../../shared/enums/payment-method.enum';
import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { Address } from '../../../shared/models/address.model';
import { Place } from '../../place/models/place.model';
import { Store } from '../../store/models/store.model';
import { Table } from '../../tables/models/table-list.model';
import { OrderStatus } from '../enums/order-status.enum';
import { OrderType } from '../enums/order-type.enum';
import { PaymentStatus } from '../enums/payment-status.enum';
import { PickupOption } from '../enums/pickup-option.enum';
import { OrderItem } from './order-item.model';
import { OrderRejectReason } from './order-reject-reason.model';
import { OrderReservation } from './order-reservation.model';

export class Order {
  id: number;
  orderNumber: number;
  status: OrderStatus;
  table: Table;
  customerName: string;
  customerPhone: string;
  customerCountryPhoneCode: string;
  orderDate: number;
  orderEndDate: number;
  orderItems: Array<OrderItem>;
  userDocument: string;
  userId: number;
  rejectReason: OrderRejectReason;
  couponCode: string;
  discount: number;
  total: number;
  paymentStatus: PaymentStatus;
  paymentMethod: PaymentMethod;
  cardBrand: string;
  paymentDate: number;
  pickupOption: PickupOption;
  deliveryAddress?: Address;
  deliveryFee: number;
  productsTotal: number;
  changeFor: number;
  delayToDelivery: number;
  orderReservation?: OrderReservation;

  store?: Store;
  place?: Place;
  subOrders: Array<Order>;
  ordersGroup: number;

  //Aux view
  showDetails: boolean; // aux Modal customer pending payment
  isPreSale: boolean;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.status != null && this.status['code'] == null) {
      this.status = UtilHelper.getEnumByCod(this.status, OrderStatus);

      if (this.status == null) {
        this.status = OrderStatus.UNDEFINED;
      }
    }
    if (this.paymentMethod != null && this.paymentMethod['code'] == null) {
      this.paymentMethod = UtilHelper.getEnumByCod(this.paymentMethod, PaymentMethod);
    }
    if (this.rejectReason != null) {
      this.rejectReason = new OrderRejectReason(this.rejectReason);
    }
    if (this.orderItems && this.orderItems.length > 0) {
      for (let i: number = 0; i < this.orderItems.length; i++) {
        this.orderItems[i] = new OrderItem(this.orderItems[i]);
      }
    }
    if (this.deliveryAddress) {
      this.deliveryAddress = new Address(this.deliveryAddress);
    }
    if (this.subOrders && this.subOrders.length > 0) {
      const subOrders: Array<Order> = [];
      this.subOrders.forEach((o: Order) => {
        subOrders.push(new Order(o));
      });
      this.subOrders = subOrders;
    }
    if (this.subOrders) {
      // Seta o orderNumber principal, se for do place ou de um store
      this.orderNumber = this.place ? this.orderNumber : this.subOrders[0].orderNumber;
    }
    if (this.customerPhone) {
      if (
        !this.customerCountryPhoneCode ||
        UtilHelper.unmask(this.customerCountryPhoneCode) == '55'
      ) {
        this.customerPhone = UtilHelper.mask(
          this.customerPhone,
          this.customerPhone.length > 10 ? '(99) 99999-9999' : '(99) 9999-9999'
        );
      }
      this.customerCountryPhoneCode = UtilHelper.unmask(this.customerCountryPhoneCode);
    }

    if (this.orderReservation && this.orderReservation.type == OrderType.PRE_SALE) {
      this.isPreSale = true;
    }
  }

  canMoveStatus(): boolean {
    const statusCanMove = [
      OrderStatus.IN_QUEUE['code'],
      OrderStatus.IN_PRODUCTION['code'],
      OrderStatus.PARTIAL_DELIVERED['code'],
    ];
    return statusCanMove.indexOf(this.status['code']) > -1;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/orders/models/order.model.ts